import { isTerminalErrorCode, Route } from '../../config/router'
import { useAmplitudeWithEnduringEventProperties } from '../../integrations/amplitude'
import { ErrorCode } from '../../model'
import { useAppRouter, useAppDispatch, setLoggedInLoadingMessageKey } from '../../state'
import { TrackingEvent } from '../../model/amplitude'
import { IdentityErrorCode, identityErrors } from '@afterpaytouch/portal-api/identity'
import { isPortalApiError } from '@afterpaytouch/portal-api'

const regulatoryErrorRouteMap: Partial<Record<IdentityErrorCode, Route>> = {
  [IdentityErrorCode.UnsuitabilityNotFound]: Route.UNSUITABILITY_QUESTION_FORM,
  [IdentityErrorCode.UnsuitabilityExpired]: Route.UNSUITABILITY_QUESTION_FORM,
  [IdentityErrorCode.AffordabilityNotFound]: Route.AFFORDABILITY_QUESTION_FORM,
  [IdentityErrorCode.AffordabilityExpired]: Route.AFFORDABILITY_QUESTION_FORM,
}

export const useRegulatoryFlow = (): { handleRegulatoryFlow: (creditLimitError: unknown) => boolean } => {
  const router = useAppRouter()
  const dispatch = useAppDispatch()
  const { logEvent } = useAmplitudeWithEnduringEventProperties()

  const handleRegulatoryFlow = (creditLimitError: unknown): boolean => {
    const errorCode = isPortalApiError(creditLimitError) ? creditLimitError.errorCode : ErrorCode.Error
    const creditLimitErrorCode = identityErrors[errorCode] ?? IdentityErrorCode.Default

    if (isTerminalErrorCode(creditLimitErrorCode)) {
      logEvent(TrackingEvent.REDIRECT_ON_REGULATORY_FLOW, {
        route: `${Route.TERMINAL_ERROR}/${creditLimitErrorCode}`,
      })
      dispatch(setLoggedInLoadingMessageKey(null))
      router.replace(`${Route.TERMINAL_ERROR}/${creditLimitErrorCode}`)
      return true
    }

    const regulatoryRoute = regulatoryErrorRouteMap[creditLimitErrorCode]
    if (regulatoryRoute !== null && regulatoryRoute !== undefined) {
      logEvent(TrackingEvent.REDIRECT_ON_REGULATORY_FLOW, {
        route: regulatoryRoute,
      })
      dispatch(setLoggedInLoadingMessageKey(null))
      router.replace(regulatoryRoute)
      return true
    }

    return false
  }

  return { handleRegulatoryFlow }
}
